import ky from 'ky'
import { httpError } from '../utils/errors'

/**
 * NumberService provides landline number search API services
 */
class NumberService {

    getRegions = () => {
        return new Promise((resolve, reject) => {
            const url = `/api/v2/purchase/regions`
            ky.get(url).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    getNumbers = (regionId) => {
        return new Promise((resolve, reject) => {
            const url = `/api/v2/purchase/regions/${regionId}/numbers`
            ky.get(url).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    getPriorNumbers = (accountId) => {
        // Returns a list of prior numbers allocated to this account and their availability
        return new Promise((resolve, reject) => {
            const url = `/api/v2/purchase/accounts/${accountId}/numbers/prior`
            ky.get(url).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }
}

// Create a singleton instance of the service to export
const instance = new NumberService();

export default instance;